import React, { useState } from "react";
import ViewButton from "../Buttons/ViewButton";
import CheckWithDate from "../CheckWithDate";
import { Box, Modal } from "@mui/material";
import ViewSelfoutingPrivileges from "../forms/ViewSelfOutingPrivileges";

function FormLineOutingPrivilege(props) {
  const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const [showViewModal, setShowViewModal] = useState(false);

  const closeViewModal = () => {
    setShowViewModal(false);
  };

  return (
    <div
      className={
        props.color === "1"
          ? "formLine60 light-grey-form"
          : "formLine60 grey-form"
      }
      style={{ width: "100%" }}
    >
      <Modal
        open={showViewModal}
        onClose={closeViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <ViewSelfoutingPrivileges {...props} closemodal={closeViewModal} />
        </Box>
      </Modal>
      {/* <div className="formLineBlock1">{props.title}</div> */}
      <div
        className="formLineBlock1"
        style={{
          minWidth: 0, // permet au flex-item de rétrécir
          overflow: "hidden", // cache le dépassement
          textOverflow: "ellipsis", // affiche les "..."
          whiteSpace: "nowrap", // une seule ligne
        }}
      >
        {props.title}
      </div>
      <div className="formLineBlock2">
        {props.signed === false || props.signed === undefined ? (
          <CheckWithDate checked={false} />
        ) : (
          <CheckWithDate checked={true} content={props.date} />
        )}
      </div>

      <div className="formLineBlock3">
        {props.signed && (
          <ViewButton handleOpen={() => props.onView(props.id)} />
        )}
      </div>
    </div>
  );
}

export default FormLineOutingPrivilege;
